import React from 'react'
import IconsAuraExp5 from './Images/IconsAuraExp5.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';




function ExpCard5() {
  return (
    

    <div className='ExpPgCard  '>
      
        <p className='ExpPgHExpName'> Miniature Painting Workshop, Udaipur </p>

        <p className='ExpPgHCat'> Craft </p>
        <p className='ExpPgHCode'> AURAMUSE105 </p>

        

        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp5} /> </div>

        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>




  )
}

export default ExpCard5